// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kJjB","importantInfo":"styles_importantInfo__2-O6Y"};